import React, { useState, useEffect } from "react";
import List from "@material-ui/core/List";
import { useDispatch, useSelector } from "react-redux";
import {
  getProductsInCart,
  getUserId,
  getUserInfo,
} from "../reducks/users/selectors";
import { CartListItem } from "../components/products";
import { PrimaryButton, GreyButton } from "../components/UIkit";
import { useCallback } from "react";
import { push } from "connected-react-router";
import { makeStyles } from "@material-ui/core";
import { JumpModal } from "../components/UIkit/modal/JumpModal";
const useStyles = makeStyles((theme) => ({
  root: {
    margin: "0 auto",
    maxWidth: 512,
    width: "100%",
  },
}));
const CartList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const user = useSelector(getUserInfo);
  const [isShowModal, setIsShowModal] = useState(false);

  // const selector = useSelector((state)=>state);
  const productsInCartRedux = useSelector(getProductsInCart) || [];
  const [productsInCart, setProductsInCart] = useState(productsInCartRedux);
  useEffect(() => {
    const updatedProducts = productsInCartRedux.map((productRedux) => {
      // 同じcartIdを持つproductsInCart内のアイテムを探す
      const existingProduct = productsInCart.find(
        (p) => p.cartId === productRedux.cartId
      );
      // 既存の製品に備考があれば、その備考を使用する
      if (existingProduct && existingProduct.remarks) {
        return { ...productRedux, remarks: existingProduct.remarks };
      } else {
        return productRedux;
      }
    });
    setProductsInCart(updatedProducts);
  }, [productsInCartRedux]);

  //備考を更新する
  const updateProductItem = useCallback(
    (cartId, newRemarks, newQuantity, newTotalPrice) => {
      setProductsInCart((currentProducts) => {
        return currentProducts.map((product) => {
          if (product.cartId === cartId) {
            return {
              ...product,
              remarks: newRemarks,
              quantity: newQuantity,
              totalPrice: newTotalPrice,
            };
          }
          return product;
        });
      });
    },
    [setProductsInCart]
  );

  const goToOrder = useCallback(() => {
    if (
      productsInCartRedux.length > 0 &&
      user.isSignedIn &&
      user.order_base_name &&
      user.order_email &&
      user.order_department_name
    ) {
      dispatch(push("/order/confirm"));
      return;
    }
    if (productsInCartRedux.length === 0) {
      dispatch(push("/"));
      return;
    } else {
      // dispatch(push("/"));
      setIsShowModal(true);
    }
  }, [productsInCartRedux.length]);

  const backToTop = useCallback(() => {
    dispatch(push("/"));
  }, []);

  return (
    <>
      <section className="c-section-wrapin">
        <h2 className="u-text__headline">ショッピングカート</h2>
        <List className={classes.root}>
          {productsInCartRedux.length > 0 &&
            productsInCartRedux.map((product) => (
              <CartListItem
                key={product.cartId}
                product={product}
                updateProductItem={(newRemarks, newQuantity, newTotalPrice) =>
                  updateProductItem(
                    product.cartId,
                    newRemarks,
                    newQuantity,
                    newTotalPrice
                  )
                }
                isEnableRemarks={true}
              />
            ))}
        </List>
        <div className="module-spacer--medium" />
        <div className="p-grid__column">
          <PrimaryButton label={"レジへ進む"} onClick={goToOrder} />
          <div className="module-spacer-extra-extra-small"></div>
          <GreyButton label={"ショッピングを続ける"} onClick={backToTop} />
        </div>
      </section>
      {isShowModal && (
        <JumpModal
          title={"警告"}
          message={"発注部署を設定してください"}
          setIsShow={setIsShowModal}
          onExec={() => dispatch(push("/user/mypage"))}
          onCancel={() => setIsShowModal(false)}
          buttonLabel={"設定する"}
        />
      )}
    </>
  );
};

export default CartList;
